export function addToFavorite(eventId, callback) {
    fetch('/rest/conference/' + eventId + '/favorite', {
        method: 'POST',
    })
        .then(res => res.json())
        .then(
            (result) => {
                callback(result);
            }
        )
}

export function removeFromFavorite(eventId, callback) {
    fetch('/rest/conference/' + eventId + '/favorite', {
        method: 'DELETE',
    })
        .then(res => res.json())
        .then(
            (result) => {
                callback(result);
            }
        )
}

export function checkIn(eventId, callback) {
    fetch('/rest/conference/' + eventId + '/checkIn', {
        method: 'POST',
    })
        .then(res => res.json())
        .then(
            (result) => {
                callback(result);
            }
        )
}
